import script from "./executive.vue?vue&type=script&setup=true&lang=js"
export * from "./executive.vue?vue&type=script&setup=true&lang=js"

import "./executive.vue?vue&type=style&index=0&id=51c48d48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c48d48"]])

export default __exports__